<div class="ad-banner-multi-editor">
  <div ngbNav #nav="ngbNav" class="nav-tabs">
    <div [ngbNavItem]="0">
      <a ngbNavLink>{{'banner.large' | translate }}</a>
      <ng-template ngbNavContent>
        <ad-banner-editor
          [definition]="adDefinition.large"
          [uploader]="largeImageUploader"
          [descriptionKey]="'banner.descriptionLarge'"
        >
        </ad-banner-editor>
      </ng-template>
    </div>
    <div [ngbNavItem]="1">
      <a ngbNavLink>{{'banner.small' | translate }}</a>
      <ng-template ngbNavContent>
        <ad-banner-editor
          [definition]="adDefinition.small"
          [uploader]="smallImageUploader"
          [descriptionKey]="'banner.descriptionSmall'"
        >
        </ad-banner-editor>
      </ng-template>
    </div>
  </div>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
